
export const fetchCountry = async () => {

    const locationReq = await fetch("https://api.country.is/");
    const location = await locationReq.json();

    return location.country;

}

export const fetchLocation = async () => {

    const locationReq = await fetch("https://api.country.is/");
    const location = await locationReq.json();

    return location;

}
